import { trigger, state, animate, transition, style, group, query, animateChild } from '@angular/animations';

const timing = '0.3s cubic-bezier(.25,.8,.25,1)';
const timingWithDelay = '0.3s 0.3s cubic-bezier(.25,.8,.25,1)';

export const fadeInAnimation = trigger('fadeInAnimation', [
  // route 'enter' transition
  transition(':enter', [
    // styles at start of transition
    style({ opacity: 0, position: 'relative', 'z-index': 2 }),

    // animation and styles at end of transition
    animate('.3s ease', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    // styles at start of transition
    style({ opacity: 1, position: 'absolute', 'z-index': 1, top: '0px', left: '0px', width: '100%', height: '100%' }),

    // animation and styles at end of transition
    animate('.3s ease', style({ opacity: 0 })),
  ]),
]);

export const fadeCleanAnimation = trigger('fadeCleanAnimation', [
  // route 'enter' transition
  transition(':enter', [
    // styles at start of transition
    style({ opacity: 0 }),

    // animation and styles at end of transition
    animate('.3s ease', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    // styles at start of transition
    style({ opacity: 1 }),

    // animation and styles at end of transition
    animate('.3s ease', style({ opacity: 0 })),
  ]),
]);

export const fadeAnimation = trigger('fadeAnimation', [
  // route 'enter' transition
  transition(':enter', [
    // styles at start of transition
    style({ opacity: 0 }),

    // animation and styles at end of transition
    animate(timing, style({ opacity: 1 })),
  ]),
  transition(':leave', [
    // styles at start of transition
    style({ opacity: 1 }),

    // animation and styles at end of transition
    animate(timing, style({ opacity: 0 })),
  ]),
]);

export const fadeInDelayAnimation = trigger('fadeInDelayAnimation', [
  // route 'enter' transition
  transition(':enter', [
    // styles at start of transition
    style({ opacity: 0 }),

    // animation and styles at end of transition
    animate(timingWithDelay, style({ opacity: 1 })),
  ]),
  transition(':leave', [
    // styles at start of transition
    style({ opacity: 1 }),

    // animation and styles at end of transition
    animate(timing, style({ opacity: 0 })),
  ]),
]);

export const fadeInDelayOnlyAnimation = trigger('fadeInDelayOnlyAnimation', [
  // route 'enter' transition
  transition(':enter', [
    // styles at start of transition
    style({ opacity: 0 }),

    // animation and styles at end of transition
    animate(timingWithDelay, style({ opacity: 1 })),
  ]),
]);

export const fadeOutAnimation = trigger('fadeOutAnimation', [
  // route 'enter' transition
  transition(':leave', [
    // styles at start of transition
    style({ opacity: 1 }),

    // animation and styles at end of transition
    animate(timing, style({ opacity: 0 })),
  ]),
]);

export const fadeOutSlowAnimation = trigger('fadeOutSlowAnimation', [
  // route 'enter' transition
  transition(':leave', [
    // styles at start of transition
    style({ opacity: 1 }),

    // animation and styles at end of transition
    animate('0.8s ease', style({ opacity: 0 })),
  ]),
]);

export const fadeInHeightAnimation = trigger('fadeInHeight', [
  // state('void', style({ 'overflow': 'hidden' })),

  // state('void', style({'height': '0px', 'overflow': 'hidden' })),
  transition(':enter', [
    style({ opacity: 0, height: 0, overflow: 'hidden' }),
    // style({ transform: 'translateY(-100%)', opacity: 0, height: 0, overflow: 'hidden' }),
    group([
      // query('@fadeInHeight',  [
      //   animateChild()
      // ], {optional: true}),
      // animate(
      //   '.15s 0s ease-out',
      //   style({
      //     transform: 'translateY(0)',
      //   })
      // ),
      animate(
        '.15s ease-out',
        style({
          opacity: 1,
        })
      ),
      animate(
        '.15s ease-out',
        style({
          height: '*',
        })
      ),
    ]),
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    group([
      animate(
        '.15s 0s ease-in',
        style({
          opacity: 0,
        })
      ),
      animate(
        '.15s ease-in',
        style({
          height: '0px',
        })
      ),
    ]),
  ]),
]);

export const fadeInHeightLinearAnimation = trigger('fadeInHeightLinear', [
  transition(
    ':enter',
    [
      style({
        transform: 'translateY(-150%)',
        opacity: 0,
        // height: 0,
        // overflow: 'hidden',
      }),
      animate(
        '.25s {{ delay}}ms linear',
        style({
          transform: 'translateY(0)',
          opacity: 1,
          // height: '*',
        })
      ),
    ],
    { params: { delay: 0 } }
  ),
  transition(
    ':leave',
    [
      style({ transform: 'translateY(0%)', opacity: 1 }),
      animate(
        '.25s {{ delay}}ms linear',
        style({
          // height: '0px',
          opacity: 0,
          transform: 'translateY({{ offset }})',
        })
      ),
    ],
    { params: { delay: 0, offset: '-150%' } }
  ),
]);

export const fadeFromBottomAnimation = trigger('fadeFromBottom', [
  transition(
    ':enter',
    [
      style({
        transform: 'translateY(150%)',
        opacity: 0,
        'pointer-events': 'none',
        // height: 0,
        // overflow: 'hidden',
      }),
      animate(
        '.15s {{ delay}}ms linear',
        style({
          transform: 'translateY(0)',
          opacity: 1,
          // height: '*',
        })
      ),
    ],
    { params: { delay: 0 } }
  ),
  transition(
    ':leave',
    [
      style({ transform: 'translateY(0%)', opacity: 1, 'pointer-events': 'none' }),
      animate(
        '.15s {{ delay}}ms linear',
        style({
          // height: '0px',
          opacity: 0,
          transform: 'translateY({{ offset }})',
        })
      ),
    ],
    { params: { delay: 0, offset: '150%' } }
  ),
]);

export const fadeFromTopAnimation = trigger('fadeFromTop', [
  transition(
    ':enter',
    [
      style({
        transform: 'translateY(-100%)',
        opacity: 0,
        'pointer-events': 'none',
        // height: 0,
        // overflow: 'hidden',
      }),
      animate(
        '.15s {{ delay}}ms linear',
        style({
          transform: 'translateY(0)',
          opacity: 1,
          // height: '*',
        })
      ),
    ],
    { params: { delay: 0 } }
  ),
  transition(
    ':leave',
    [
      style({ transform: 'translateY(0%)', opacity: 1, 'pointer-events': 'none' }),
      animate(
        '.15s {{ delay}}ms linear',
        style({
          // height: '0px',
          opacity: 0,
          transform: 'translateY({{ offset }})',
        })
      ),
    ],
    { params: { delay: 0, offset: '-150%' } }
  ),
]);

export const fadeInWidthAnimation = trigger('fadeInWidth', [
  // state('void', style({ 'overflow': 'hidden' })),

  // state('void', style({'height': '0px', 'overflow': 'hidden' })),
  transition(':enter', [
    style({ transform: 'translateX(100%)', opacity: 0, width: 0, overflow: 'hidden' }),
    group([
      animate(
        '.15s 0s ease-out',
        style({
          transform: 'translateX(0)',
        })
      ),
      animate(
        '.15s ease-out',
        style({
          opacity: 1,
        })
      ),
      animate(
        '.15s ease-out',
        style({
          width: '*',
        })
      ),
    ]),
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    group([
      animate(
        '.15s 0s ease-in',
        style({
          opacity: 0,
        })
      ),
      animate(
        '.15s ease-in',
        style({
          width: '0px',
          transform: 'translateX(20%)',
        })
      ),
    ]),
  ]),
]);

export const widthAnimation = trigger('widthAnimation', [
  // state('void', style({ 'overflow': 'hidden' })),

  // state('void', style({'height': '0px', 'overflow': 'hidden' })),
  transition(':enter', [
    style({ opacity: 0, width: 0, overflow: 'hidden' }),

    animate(
      '.15s ease-out',
      style({
        width: '*',
        opacity: 1
      })
    ),
  ]),
  transition(':leave', [
    style({ overflow: 'hidden', width: '*', opacity: 1 }),
    animate(
      '.15s ease-in',
      style({
        width: 0,
        opacity: 0
      })
    ),
  ]),
]);

export const moveRightAnimation = trigger('moveRight', [
  // state('void', style({ 'overflow': 'hidden' })),

  // state('void', style({'height': '0px', 'overflow': 'hidden' })),
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    group([
      animate(
        '.25s 0s ease-out',
        style({
          transform: 'translateX(0)',
        })
      ),
    ]),
  ]),
  transition(':leave', [
    style({ transform: 'translateX(0%)' }),
    group([
      animate(
        '.15s ease-in',
        style({
          transform: 'translateX(100%)',
        })
      ),
    ]),
  ]),
]);
